export enum LoanTypeForFields {
  MULTIFAMILYMIXEDUSE = "Multifamily/MixedUse",
  SFR = "Single Family/Detached",
  UNIT_24 = "2-4 Unit",
  CONDO = "Condo",
  TOWNHOME = "Townhome",
}